var React = require('react');

function Terminal (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#001b35;}")),React.createElement("path",{"className":"cls-1","d":"M18.9,11.86H17.7V5.55A1.52,1.52,0,0,0,16.17,4H7.83A1.52,1.52,0,0,0,6.3,5.55v6.31H5.1A1.08,1.08,0,0,0,4,12.94v6A1.08,1.08,0,0,0,5.1,20H18.9A1.08,1.08,0,0,0,20,18.9v-6A1.08,1.08,0,0,0,18.9,11.86ZM16,5.43a.37.37,0,0,1,.37.36v6.07H14.17V5.43Zm-8.33.36A.37.37,0,0,1,8,5.43h4.15v6.43H7.65Z","key":1})]);
}

Terminal.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Terminal;

Terminal.default = Terminal;
